import { createTheme } from "@mui/material/styles";

const difficulties = ["簡易", "中等", "困難"];

function UserConfig() {
  // 如果有現成的就丟回去 沒有的話 執行第一次建構
  if (typeof UserConfig.cache === "object") {
    return UserConfig.cache;
  }
  this.hkoLang = "tc";
  UserConfig.cache = this;
}

function AppSingleton() {
  if (typeof AppSingleton.cache === "object") {
    return AppSingleton.cache;
  }
  // TODO: binding the leave page and navigation
  this.topBarHeight = 64; // MARK: Now only for recycling game
  this.isDarkMode = true;
  this.setIsDarkModel = () => {};
  this.fontScale = 1.0;
  this.setFontScale = () => {};
  this.mirrorFPS = 15;
  this.setMirrorFPS = () => {};
  this.mirrorDifficulty = "簡易";
  this.setMirrorDifficulty = () => {};
  this.isEffect = true;
  this.setIsEffect = () => {};

  this.leavePage = () => {
    const onAnimationCompleted = () => {
      this.navigate(-1);
    };
    return onAnimationCompleted;
  };
  this.theme = createTheme({
    transitions: {
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
      },
    },
  });
  AppSingleton.cache = this;
}

const data_list = [
  // MARK: x.2 玉娟
  {
    exercise_id: "V1.1-ts",
    title: "第一式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，雙手交叉放胸前。",
    type: "helper1",
    duration: 45,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "雙手交叉"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-ts.mp4",
  },
  {
    exercise_id: "V2.1-ts",
    title: "第二式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，十指緊扣放胸前。",
    type: "helper1",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V2.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V2.1-ts.mp4",
  },
  {
    exercise_id: "V3.1-ts",
    title: "第三式",
    subtitle: "雙臂平肩(同膊頭同高度)向右移，頭望向左；雙臂平肩(同膊頭同高度)向左移，頭望向右。",
    type: "helper1",
    duration: 41,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "頭頸"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V3.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V3.1-ts.mp4",
  },
  {
    exercise_id: "V4.1-ts",
    title: "第四式",
    subtitle: "上拍拍、下拍拍、右拍拍、左拍拍。",
    type: "helper1",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "拍拍手"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V4.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V4.1-ts.mp4",
  },
  // {
  //   exercise_id: "V5.1-ts",
  //   title: "第五式",
  //   subtitle:
  //     "豎起兩雙拇指；雙臂平肩(同膊頭同高度)向右側，雙臂向上劃半圓，由右移至左；雙臂平肩(同膊頭同高度)向左側，雙臂向上劃半圓，由左移至右。",
  //       type: "helper1",
  //   duration: 42,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "雙臂", "拇指", "劃半圓"],
  // trainer: "指導員 葵心",
  //   imageUrl: "https://sso.reality-connect.tech/img/V5.1-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V5.1-ts.mp4",
  // },
  // {
  //   exercise_id: "V6.1-ts",
  //   title: "第六式",
  //   subtitle: "紮馬握拳；右直拳後拍左大腿；左直拳後拍右大腿。",
  //       type: "helper1",
  //   duration: 44,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "握拳", "拍大腿"],
  // trainer: "指導員 葵心",
  //   imageUrl: "https://sso.reality-connect.tech/img/V6.1-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V6.1-ts.mp4",
  // },
  // {
  //   exercise_id: "V7.1-ts",
  //   title: "第七式",
  //   subtitle:
  //     "屈曲手肘(踭)，前臂右直左橫；向側打開雙臂，伸直手肘(踭)；屈曲手肘(踭)，前臂左直右橫；向側打開雙臂，伸直手肘(踭)。",
  //      type: "helper1",
  //   duration: 44,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "屈曲手肘", "打開雙臂"],
  // trainer: "指導員 葵心",
  //   imageUrl: "https://sso.reality-connect.tech/img/V7.1-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V7.1-ts.mp4",
  // },
  // {
  //   exercise_id: "V8.1-ts",
  //   title: "第八式",
  //   subtitle:
  //     "舉高右手，屈曲(埋)手肘(踭)至平肩(同膊頭同高度)，拍左肩(膊頭)，最後手放右大腿上；舉高左手，屈曲(埋)手肘(踭)至平肩(同膊頭同高度)，拍右肩(膊頭)，最後手放左大腿上。",
  //       type: "helper1",
  //   duration: 44,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "雙臂", "舉手", "手平放大腿"],
  // trainer: "指導員 葵心",
  //   imageUrl: "https://sso.reality-connect.tech/img/V8.1-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V8.1-ts.mp4",
  // },
  {
    exercise_id: "V1.1-V2.1-ts",
    title: "組合招式 (一)",
    subtitle: "第一式 + 第二式",
    type: "helper1",
    duration: 89,
    diffculty: "加強版",
    tags: ["雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-V2.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-V2.1-ts.mp4",
  },
  {
    exercise_id: "V1.1-V4.1-ts",
    title: "組合招式 (二)",
    subtitle: "第一式 至 第四式",
    type: "helper1",
    duration: 177,
    diffculty: "高級級",
    tags: ["雙臂", "手肘", "十指緊扣", "頭頸", "拍拍手"],
    trainer: "指導員 葵心",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-V4.1-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-V4.1-ts.mp4",
  },

  // MARK: x.2 玉娟
  {
    exercise_id: "V1.2-ts",
    title: "第一式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，雙手交叉放胸前。",
    type: "helper2",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "雙手交叉"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-ts.mp4",
  },
  {
    exercise_id: "V2.2-ts",
    title: "第二式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，十指緊扣放胸前。",
    type: "helper2",
    duration: 46,
    tags: ["全程安坐", "雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V2.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V2.2-ts.mp4",
  },
  {
    exercise_id: "V3.2-ts",
    title: "第三式",
    subtitle: "雙臂平肩(同膊頭同高度)向右移，頭望向左；雙臂平肩(同膊頭同高度)向左移，頭望向右。",
    type: "helper2",
    duration: 48,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "頭頸"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V3.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V3.2-ts.mp4",
  },
  {
    exercise_id: "V4.2-ts",
    title: "第四式",
    subtitle: "上拍拍、下拍拍、右拍拍、左拍拍。",
    type: "helper2",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "拍拍手"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V4.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V4.2-ts.mp4",
  },
  // {
  //   exercise_id: "V5.2-ts",
  //   title: "第五式",
  //   subtitle:
  //     "豎起兩雙拇指；雙臂平肩(同膊頭同高度)向右側，雙臂向上劃半圓，由右移至左；雙臂平肩(同膊頭同高度)向左側，雙臂向上劃半圓，由左移至右。",
  //       type: "helper2",
  //   duration: 45,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "雙臂", "拇指", "劃半圓"],
  // trainer: "指導員 玉娟",
  //   imageUrl: "https://sso.reality-connect.tech/img/V5.2-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V5.2-ts.mp4",
  // },
  // {
  //   exercise_id: "V6.2-ts",
  //   title: "第六式",
  //   subtitle: "紮馬握拳；右直拳後拍左大腿；左直拳後拍右大腿。",
  //       type: "helper2",
  //   duration: 46,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "握拳", "拍大腿"],
  // trainer: "指導員 玉娟",
  //   imageUrl: "https://sso.reality-connect.tech/img/V6.2-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V6.2-ts.mp4",
  // },
  // {
  //   exercise_id: "V7.2-ts",
  //   title: "第七式",
  //   subtitle:
  //     "屈曲手肘(踭)，前臂右直左橫；向側打開雙臂，伸直手肘(踭)；屈曲手肘(踭)，前臂左直右橫；向側打開雙臂，伸直手肘(踭)。",
  //  type: "helper2",
  //   duration: 45,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "屈曲手肘", "打開雙臂"],
  // trainer: "指導員 玉娟",
  //   imageUrl: "https://sso.reality-connect.tech/img/V7.2-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V7.2-ts.mp4",
  // },
  // {
  //   exercise_id: "V8.2-ts",
  //   title: "第八式",
  //   subtitle:
  //     "舉高右手，屈曲(埋)手肘(踭)至平肩(同膊頭同高度)，拍左肩(膊頭)，最後手放右大腿上；舉高左手，屈曲(埋)手肘(踭)至平肩(同膊頭同高度)，拍右肩(膊頭)，最後手放左大腿上。",
  // type: "helper2",
  //   duration: 44,
  //   diffculty: "入門級",
  //   tags: ["全程安坐", "雙臂", "舉手", "手平放大腿"],
  // trainer: "指導員 玉娟",
  //   imageUrl: "https://sso.reality-connect.tech/img/V8.2-ts.png",
  //   videoUrl: "https://sso.reality-connect.tech/video/V8.2-ts.mp4",
  // },
  {
    exercise_id: "V1.2-V2.2-ts",
    title: "組合招式 (一)",
    subtitle: "第一式 + 第二式",
    type: "helper2",
    duration: 89,
    diffculty: "加強版",
    tags: ["雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-V2.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-V2.2-ts.mp4",
  },
  {
    exercise_id: "V1.2-V4.2-ts",
    title: "組合招式 (二)",
    subtitle: "第一式 至 第四式",
    type: "helper2",
    duration: 177,
    diffculty: "高級級",
    tags: ["雙臂", "手肘", "十指緊扣", "頭頸", "拍拍手"],
    trainer: "指導員 玉娟",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-V4.2-ts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-V4.2-ts.mp4",
  },

  // avatar 1 male
  {
    exercise_id: "V1.1-cts",
    title: "第一式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，雙手交叉放胸前。",
    type: "avatar1",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "雙手交叉"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-cts.mp4",
  },
  {
    exercise_id: "V2.1-cts",
    title: "第二式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，十指緊扣放胸前。",
    type: "avatar1",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V2.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V2.1-cts.mp4",
  },
  {
    exercise_id: "V3.1-cts",
    title: "第三式",
    subtitle: "雙臂平肩(同膊頭同高度)向右移，頭望向左；雙臂平肩(同膊頭同高度)向左移，頭望向右。",
    type: "avatar1",
    duration: 48,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "頭頸"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V3.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V3.1-cts.mp4",
  },
  {
    exercise_id: "V4.1-cts",
    title: "第四式",
    subtitle: "上拍拍、下拍拍、右拍拍、左拍拍。",
    type: "avatar1",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "拍拍手"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V4.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V4.1-cts.mp4",
  },
  {
    exercise_id: "V1.1-V2.1-cts",
    title: "組合招式 (一)",
    subtitle: "第一式 + 第二式",
    type: "avatar1",
    duration: 66,
    diffculty: "加強版",
    tags: ["雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-V2.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-V2.1-cts.mp4",
  },
  {
    exercise_id: "V1.1-V4.1-cts",
    title: "組合招式 (二)",
    subtitle: "第一式 至 第四式",
    type: "avatar1",
    duration: 131,
    diffculty: "高級級",
    tags: ["雙臂", "手肘", "十指緊扣", "頭頸", "拍拍手"],
    trainer: "指導員 元氣大叔",
    imageUrl: "https://sso.reality-connect.tech/img/V1.1-V4.1-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.1-V4.1-cts.mp4",
  },

  // MARK: avatar 2 female
  {
    exercise_id: "V1.2-cts",
    title: "第一式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，雙手交叉放胸前。",
    type: "avatar2",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "雙手交叉"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-cts.mp4",
  },
  {
    exercise_id: "V2.2-cts",
    title: "第二式",
    subtitle: "吸氣，向側打開雙臂，伸直手肘(踭)；呼氣，十指緊扣放胸前。",
    type: "avatar2",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V2.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V2.2-cts.mp4",
  },
  {
    exercise_id: "V3.2-cts",
    title: "第三式",
    subtitle: "雙臂平肩(同膊頭同高度)向右移，頭望向左；雙臂平肩(同膊頭同高度)向左移，頭望向右。",
    type: "avatar2",
    duration: 48,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "頭頸"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V3.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V3.2-cts.mp4",
  },
  {
    exercise_id: "V4.2-cts",
    title: "第四式",
    subtitle: "上拍拍、下拍拍、右拍拍、左拍拍。",
    type: "avatar2",
    duration: 46,
    diffculty: "入門級",
    tags: ["全程安坐", "雙臂", "拍拍手"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V4.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V4.2-cts.mp4",
  },
  {
    exercise_id: "V1.2-V2.2-cts",
    title: "組合招式 (一)",
    subtitle: "第一式 + 第二式",
    type: "avatar2",
    duration: 78,
    diffculty: "加強版",
    tags: ["雙臂", "手肘", "十指緊扣"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-V2.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-V2.2-cts.mp4",
  },
  {
    exercise_id: "V1.2-V4.2-cts",
    title: "組合招式 (二)",
    subtitle: "第一式 至 第四式",
    type: "avatar2",
    duration: 139,
    diffculty: "高級級",
    tags: ["雙臂", "手肘", "十指緊扣", "頭頸", "拍拍手"],
    trainer: "指導員 活力小姐",
    imageUrl: "https://sso.reality-connect.tech/img/V1.2-V4.2-cts.png",
    videoUrl: "https://sso.reality-connect.tech/video/V1.2-V4.2-cts.mp4",
  },
];

export { AppSingleton, data_list, difficulties, UserConfig };
